import { render } from "./ToggleButton.vue?vue&type=template&id=621055b1&scoped=true&ts=true"
import script from "./ToggleButton.vue?vue&type=script&lang=ts"
export * from "./ToggleButton.vue?vue&type=script&lang=ts"

import "./ToggleButton.vue?vue&type=style&index=0&id=621055b1&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/rontend-vue_version_release-euau/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-621055b1"]])

export default __exports__